module.exports = __webpack_public_path__ + "asset/consent-to-act-as-director-pdf--7c4d5a.png";